import axios, { AxiosResponse } from "axios";
import { SpecialSessionRequest } from "./../interfaces/special-sessions/SpecialSessionRequest";
import { ConfirmSpecialSessionDeletionResponse } from "../interfaces/special-sessions/ConfirmSpecialSessionDeletionResponse";
import { SpecialSessionDetailsResponse } from "../interfaces/special-sessions/SpecialSessionDetailsResponse";
import { SpecialSessionResponse } from "../interfaces/special-sessions/SpecialSessionResponse";
import { SetIsFeaturedOnParticipantsListRequest } from "../interfaces/special-sessions/SetIsFeaturedOnParticipantsListRequest";
import { getAuthenticationHeaders } from "../utils/authenticationsUtils";

const SPECIAL_SESSIONS_API_URL: string = `${process.env.REACT_APP_API_URL}/special-sessions`;

const getAllSpecialSessions = async (): Promise<SpecialSessionResponse[]> => {
  const getAllSpecialSessionsResponse = await axios.get(
    `${SPECIAL_SESSIONS_API_URL}/all`
  );
  return getAllSpecialSessionsResponse.data;
};

const getAllSpecialSessionsWithDeleted = async (): Promise<
  SpecialSessionDetailsResponse[]
> => {
  const getAllSpecialSessionsWithDeletedResponse = await axios.get(
    `${SPECIAL_SESSIONS_API_URL}/all-with-deleted`
  );
  return getAllSpecialSessionsWithDeletedResponse.data;
};

const createSpecialSession = async (
  createSpecialSessionRequest: SpecialSessionRequest
): Promise<AxiosResponse<any, any>> => {
  const headers = getAuthenticationHeaders();

  const createSpecialSessionResponse = await axios.post(
    `${SPECIAL_SESSIONS_API_URL}/create`,
    createSpecialSessionRequest,
    { headers }
  );

  return createSpecialSessionResponse.data;
};

const updateSpecialSession = async (
  id: string,
  updateSpecialSessionRequest: SpecialSessionRequest
): Promise<SpecialSessionResponse> => {
  const headers = getAuthenticationHeaders();

  const updateSpecialSessionResponse = await axios.put(
    `${SPECIAL_SESSIONS_API_URL}/update/${id}`,
    updateSpecialSessionRequest,
    { headers }
  );

  return updateSpecialSessionResponse.data;
};

const deleteSpecialSession = async (
  id: string
): Promise<SpecialSessionDetailsResponse> => {
  const headers = getAuthenticationHeaders();

  const deleteSpecialSessionResponse = await axios.delete(
    `${SPECIAL_SESSIONS_API_URL}/delete/${id}`,
    { headers }
  );

  return deleteSpecialSessionResponse.data;
};

const confirmSpecialSessionDeletion = async (
  id: string
): Promise<ConfirmSpecialSessionDeletionResponse> => {
  const headers = getAuthenticationHeaders();

  const confirmSpecialSessionDeletionResponse = await axios.delete(
    `${SPECIAL_SESSIONS_API_URL}/confirm-deletion/${id}`,
    { headers }
  );

  return confirmSpecialSessionDeletionResponse.data;
};

const restoreSpecialSession = async (
  id: string
): Promise<SpecialSessionDetailsResponse> => {
  const headers = getAuthenticationHeaders();

  const restoreSpecialSessionResponse = await axios.post(
    `${SPECIAL_SESSIONS_API_URL}/restore/${id}`,
    {},
    { headers }
  );
  
  return restoreSpecialSessionResponse.data;
};

const setIsFeaturedOnParticipantsList = async (
  id: string,
  setIsFeaturedOnParticipantsListRequest: SetIsFeaturedOnParticipantsListRequest
): Promise<SpecialSessionResponse> => {
  const headers = getAuthenticationHeaders();

  const setIsFeaturedOnParticipantsListResponse = await axios.put(
    `${SPECIAL_SESSIONS_API_URL}/set-is-featured-on-participants-list/${id}`,
    setIsFeaturedOnParticipantsListRequest,
    { headers }
  );

  return setIsFeaturedOnParticipantsListResponse.data;
};

const specialSessionsService = {
  getAllSpecialSessions,
  getAllSpecialSessionsWithDeleted,
  createSpecialSession,
  updateSpecialSession,
  deleteSpecialSession,
  confirmSpecialSessionDeletion,
  restoreSpecialSession,
  setIsFeaturedOnParticipantsList,
};

export default specialSessionsService;